export default __webpack_public_path__ + "static/media/sbo-title-en.2ea153c0.webp";